module.exports = __webpack_public_path__ + "img/bannerServicios.5408f25e.jpg";